import React from 'react';

const UploadIcon = ({ width = 40, height = 40, color = '#0A0A0B' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3333 27.1604H16.6666C15.75 27.1604 15 26.4104 15 25.4937V17.1604H12.35C10.8666 17.1604 10.1333 15.3604 11.1833 14.3104L18.8333 6.66042C19.1447 6.34833 19.5675 6.17294 20.0083 6.17294C20.4492 6.17294 20.8719 6.34833 21.1833 6.66042L28.8333 14.3104C29.8833 15.3604 29.1333 17.1604 27.65 17.1604H25V25.4937C25 26.4104 24.25 27.1604 23.3333 27.1604ZM30 30.4938H10C9.08333 30.4938 8.33333 31.2438 8.33333 32.1604C8.33333 33.0771 9.08333 33.8271 10 33.8271H30C30.9167 33.8271 31.6667 33.0771 31.6667 32.1604C31.6667 31.2438 30.9167 30.4938 30 30.4938Z"
      fill={color}
    />
  </svg>
);

export default UploadIcon;
